import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";
import Button from "../../components/common/Button";
import Text from "../../components/common/Text";
import FlexBox from "../../components/common/FlexBox";
import Div from "../../components/common/Div";
import HR from "../../components/common/HR";
import IconBar from "../Partials/IconBar";
import SubmitTestBox from "../Partials/SubmitTestBox";
import Question from "../Tests/Question";
import { getTime } from "../../constants/Constants";
import {
  tenzero,
  urlbase,
  headers,
  NumberToLetter,
  LetterToNumber,
} from "../../constants/Constants";
import ReviewBox from "../Partials/ReviewBox";
import { usePersistentState } from "react-persistent-state";
import { beginTest, SubmitTest } from "../../api/test";
import { deflateRaw } from "node:zlib";
import { Box, Typography } from "@mui/material";
import "../../../src/pages/Admin/Styling.css";

//fixed options save
export default function Test(props) {
  const history = useHistory();
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined ||
    props.location.state.test === undefined ||
    props.location.state.questions === undefined
  )
    history.push("/login");

  const user = props.location.state.user;
  const test = props.location.state.test;
  const questions = props.location.state.questions;
  const grouptest = props.location.state.grouptest;
  const [startTime, setStartTime] = useState(new Date());
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [questionNumber, setQuestionNumber] = useState(
    parseInt(localStorage.getItem("QuestionNumber"))
  );

  var options = JSON.parse(localStorage.getItem("Options"));

  const numberOfQuestions = questions.length;
  var arr = Array.apply(null, Array(numberOfQuestions)); //.map(function () {}); //mapping the blank method seems redundant, as the array is already populated with undefined's
  if (localStorage.getItem("Submission") !== "") {
    var tempStr = localStorage.getItem("NumberEntries");
    var tempArr = tempStr.split(",");
    var sum = 0;
    var TempArr = localStorage.getItem("Submission").split(",");
    var Temp = [];
    var count = 0;
    for (var x = 0; x < tempArr.length; x++) {
      if (tempArr[x] !== "") {
        var tempCount = parseInt(tempArr[x]);

        if (tempCount === 1) {
          Temp[x] = TempArr[count];
          count++;
        } else {
          //there needs to be an array
          var newArr = [];
          for (var y = count; y < count + tempCount; y++)
            newArr[newArr.length] = TempArr[y];
          count += tempCount;
          Temp[x] = newArr;
        }
      }
    }

    arr = Temp;
  }

  if (localStorage.getItem("StartTime") !== "") {
    var temp = localStorage.getItem("StartTime");
  }

  const [submission, setSubmission] = useState(arr); //why use a stateful component for this?

  if (
    props.location.state.submission !== undefined &&
    !checkArrayAllUndef(submission)
  )
    //checks if a submission has been given with the constructor call, must also only load submission from the props if submission hasn't already been set, else infinite looping
    setSubmission(props.location.state.submission);

  const [submitDisplay, setSubmitDisplay] = useState(false);

  const [timeUsed, setTimeUsed] = useState();

  // function updateSubmission(arr) {
  //   submission[0] = arr;
  // }

  function checkArrayAllUndef(arr) {
    return arr.some((el) => el !== undefined);
  }

  function QuestionManager() {
    const question = questions[questionNumber];
    const content = (
      <Div
        height={"100%"}
        width={"100%"}
        backgroundColor={"white"}
        borderRadius={"5px"}
        marginBottom={"20px"}
        paddingBottom={"20px"}
        fontSize={"1rem"}
      >
        <InfoBar />
        <Question
          fontSize={"1rem"}
          alignItems={"left"}
          question={question}
          submission={submission}
          questionNumber={questionNumber}
          setSubmission={(x) => {
            setSubmission(x);
            localStorage.setItem("Submission", x.toString());
          }}
        />
        <br />
      </Div>
    );
    return content;
  }

  function timeOut() {
    SubmitTestHandler();
  }

  function toHome() {
    submitWithoutReview();
  }

  function setTimer() {
    let date = new Date(startTime);
    date.setMinutes(date.getMinutes() + test.timealloc);
    return date;
  }

  function InfoBar() {
    return (
      <Div margin={"10px auto auto auto"}>
        <div></div>
        <Box
          color={"#000"}
          display={"flex"}
          flexDirection={"row"}
          width={"100%"}
          sx={{ backgroundColor: "#fbcd02" }}
          borderRadius={"5px"}
          marginTop={"10px"}
        >
          <Typography
            width={"50%"}
            margin={"5px auto auto 5px"}
            padding={"10px"}
            textAlign={"left"}
            fontSize={"small"}
            style={{ fontWeight: "bold" }}
          >
            {questionNumber + 1} of {numberOfQuestions}
          </Typography>
          <Typography
            width={"50%"}
            margin={"5px 5px auto auto"}
            padding={"10px"}
            style={{ fontWeight: "bold" }}
            textAlign={"right"}
            fontSize={"small"}
          >
            <Countdown
              date={setTimer()}
              daysInHours={true}
              onComplete={timeOut}
            />
          </Typography>
        </Box>
        <Div></Div>
      </Div>
    );
  }

  function BackHandler() {
    setQuestionNumber(questionNumber - 1);
    localStorage.setItem("QuestionNumber", questionNumber.toString());
  }
  function NextHandler() {
    if (questionNumber === questions.length - 1) submitTest();
    else {
      setQuestionNumber(questionNumber + 1);
      localStorage.setItem("QuestionNumber", questionNumber.toString());
      localStorage.setItem("Submission", submission.toString());
    }
  }

  function submitTest() {
    setSubmitDisplay(true);
  }

  function determineSubmission(question, value, index) {
    if (
      (question.type !== "single" &&
        question.type !== "multiple" &&
        question.type !== "true/false" &&
        question.type !== "number") ||
      value === undefined
    )
      return "";

    if (question.type === "single") {
      return value === NumberToLetter(index) ? 1 : 0;
    }
    if (question.type === "true/false") {
      return value === question.options[index].text.toUpperCase() ? 1 : 0;
    }
    if (question.type === "number") {
      return value[1] === NumberToLetter(index);
    }
    if (question.type === "multiple") {
      return value.includes(NumberToLetter(index));
    }
  }

  function createQuestionSubmissionObject() {
    let questionArr = [];
    var tempQArr = questions;
    for (var i = 0; i < questions.length; i++) {
      let Options = [];
      for (var j = 0; j < options[i].length; j++) {
        const option = {
          answer:
            (questions[i].type === "order" || questions[i].type === "match") &&
            submission[i] !== undefined &&
            submission[i][j] !== undefined
              ? submission[i][j]
              : "", // answer for order or column match
          isCorrect: options[i][j].correct,
          isSelected: determineSubmission(questions[i], submission[i], j), // single or multiple types, or number
          optionID: options[i][j].id,
          correctAnswer: options[i][j].text,
        };
        Options.push(option);
      }
      let question = {
        answer:
          (questions[i].type === "text" || questions[i].type === "number") &&
          submission[i] !== undefined &&
          submission[i][0] !== undefined
            ? submission[i][0]
            : "", // type or number question
        id: questions[i].id,
        test_id: test.id,
        type: questions[i].type,
        options: Options,
      };
      questionArr.push(question);
    }
    return questionArr;
  }

  const submitWithoutReview = async () => {
    const grouptest_id =
      grouptest !== undefined ? "&grouptest_id=".concat(grouptest.id) : "";

    const finishTime = new Date();
    localStorage.setItem("time", getTime(startTime));

    //let diffTime = Math.abs((finishTime.getTime()-startTime.getTime()))
    //diffTime = diffTime / 1000
    //let diffTimeInMinutes = diffTime / 60
    // let finalTimeDiff = diffTimeInMinutes.toFixed(2)
    // /*    const url = urlbase()
    //       .concat('test/submit?token=')
    //       .concat(user.token)
    //       .concat('&test_id=')
    //       .concat(test.id)
    //       .concat(grouptest_id);*/
    const questionSubmission = createQuestionSubmissionObject();

    let body;
    if (grouptest === undefined)
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        test_version: test.version,
        device_id: "",
      };
    else
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        grouptest_id: grouptest.id,
        device_id: "",
        test_version: test.version,
      };

    const submitResponse = await SubmitTest(
      user.token,
      test.id,
      body,
      grouptest_id
    );

    if (submitResponse.code === 200) {
      history.push("/results", {
        user: user,
        error: false,
        test: test,
        questions: questions,
        submission: submission,
        data: submitResponse.data,
        grouptest: grouptest,
      });
    } else {
      history.push("/login");
    }
  };

  const SubmitTestHandler = async () => {
    const grouptest_id =
      grouptest !== undefined ? "&grouptest_id=".concat(grouptest.id) : "";
    const finishTime = new Date();

    localStorage.setItem("time", getTime(startTime));

    let diffTime = Math.abs(finishTime.getTime() - startTime.getTime());
    diffTime = diffTime / 1000;
    let diffTimeInMinutes = diffTime / 60;
    let finalTimeDiff = diffTimeInMinutes.toFixed(2);

    const url = urlbase()
      .concat("test/submit?token=")
      .concat(user.token)
      .concat("&test_id=")
      .concat(test.id)
      .concat(grouptest_id);
    const questionSubmission = createQuestionSubmissionObject();

    let body;
    if (grouptest === undefined)
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        test_version: test.version,
      };
    else
      body = {
        token: user.token,
        test_id: test.id,
        questions: questionSubmission,
        start_time: startTime,
        grouptest_id: grouptest.id,
        device_id: "",
        test_version: test.version,
      };

    const submitResponse = await SubmitTest(
      user.token,
      test.id,
      body,
      grouptest_id
    );

    if (submitResponse.code === 200) {
      history.push("/results", {
        user: user,
        error: false,
        test: test,
        questions: questions,
        submission: submission,
        data: submitResponse.data,
        grouptest: grouptest,
      });
    } else {
      history.push("/results", {
        user: user,
        data: submitResponse.data,
        error: true,
      });
    }
  };
  var numberEntries = [];
  for (var x = 0; x < numberOfQuestions; x++) {
    if (submission[x] !== undefined) {
      if (submission[x].length === undefined) {
        //then the current entry is an object
        numberEntries[x] = 1;
      } else {
        if (questions[x].type === "true/false") numberEntries[x] = 1;
        else numberEntries[x] = submission[x].length;
      }
    }
  }

  localStorage.setItem("NumberEntries", numberEntries.toString());
  function ForwardBackButtons() {
    const isFirstQuestion = questionNumber === 0;
    const submit = questionNumber === questions.length - 1;

    return (
      <Div
        marginTop={"20px"}
        width={"100%"}
        flexDirection={"row"}
        display={"flex"}
        style={{
          display: "flex",
          justifyContent: "left",
        }}
      >
        {!isFirstQuestion && (
          <div style={{ width: "100%", marginRight: "10px" }}>
            <Button
              backgroundColor={"#fbcd02"}
              color={"#00112e"}
              borderRadius={"5px"}
              width={"100%"}
              height={"40px"}
              fontWeight={"bold"}
              style={{ marginRight: "10px" }}
              onClick={BackHandler}
              disabled={questionNumber < 1}
            >
              BACK
            </Button>
          </div>
        )}
        <div
          style={{ marginLeft: isFirstQuestion ? "0" : "10px", width: "100%" }}
        >
          <Button
            backgroundColor={"#fbcd02"}
            color={"#00112e"}
            borderRadius={"5px"}
            width={"100%"}
            height={"40px"}
            fontWeight={"bold"}
            onClick={NextHandler}
          >
            {submit ? "SUBMIT" : "NEXT"}
          </Button>
        </div>
      </Div>
    );
  }

  const StartTest = async () => {
    const startTestResponse = await beginTest(user.token, test.id);

    if (startTestResponse.code === 200) {
      if (localStorage.getItem("StartTime") === "") {
        setStartTime(new Date());
      } else {
        setStartTime(new Date(Date.parse(localStorage.getItem("StartTime"))));
      }
      localStorage.setItem("StartTime", startTime.toString());
    } else {
      console.log(startTestResponse);
      return <></>;
    }
  };

  const submitDisplayYes = () => {
    SubmitTestHandler();
  };

  useEffect(() => {
    const abortController = new AbortController();
    QuestionManager();
    StartTest();
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ReviewBox
        display={submitDisplay}
        handler1={toHome}
        handler2={() => {
          history.push("/review", {
            user: user,
            test: test,
            questions: questions,
            submission: submission,
            startTime: startTime,
            grouptest: grouptest,
          });
        }}
        // handler2={submitDisplayYes}
      />

      <Box
        style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}
      >
        <Box style={{ padding: "10px 0" }}>
          <IconBar
            location={"test"}
            user={user}
            style={{ marginBottom: "0px" }}
          />
          <Box
            style={{
              marginTop: "10px",
              fontSize: "1.1rem",
              backgroundColor: "#212a41",
              padding: "10px 15px",
              borderRadius: "5px",
            }}
          >
            <Typography
              style={{
                color: "#FBCD02",
                marginTop: "10px",
                fontSize: "1.1rem",
                backgroundColor: "#212a41",
                paddingTop: "10px",
                paddingBottom: "10px",
                borderRadius: "5px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {test.name}
            </Typography>

            {QuestionManager()}
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <ForwardBackButtons />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
